<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-user-friends"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="personForm" :labelColumnSize="3">
      <FormRow label="Title"><FormSelect v-model="person.title" field="title" :options="personTitleOptions" /></FormRow>
      <FormRow label="First name"><FormInputText placeholder="Firstname" v-model="person.firstName" field="firstName" /></FormRow>
      <FormRow label="Last name"><FormInputText placeholder="Lastname" v-model="person.lastName" field="lastName" /></FormRow>
      <FormRow label="Position"><FormInputText placeholder="Position" v-model="person.position" field="position" /></FormRow>
      <FormRow label="Email"><FormInputEmail placeholder="Email" v-model="person.email" field="email" /></FormRow>
      <FormRow label="Phone"><FormInputText placeholder="Phone" v-model="person.phone" field="phone" /></FormRow>
      <FormRow label="Mobile"><FormInputText placeholder="Mobile" v-model="person.mobile" field="mobile" /></FormRow>
      <FormRow label="Notes"><FormInputTextArea placeholder="Notes" v-model="person.note" field="note" /></FormRow>
      <FormRow label="Labels"><FormLabelTag popupName="Person Labels" v-model="person.labelList" labelType="contactPerson" field="tagList" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { PersonTitleLookup } from '@/store/types'

export default {
  name: "ContactPersonDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      personId: null,
      person: {
        labelList: []   // JB FIXME: Have to reset this as label control doesn't listen... 
      },
      personForm: {},
      submitting: false,
      personTitleOptions: PersonTitleLookup
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Person' : 'Edit Person'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(person) {
      // Reset form
      this.person = {
        labelList: []
      }
      this.personId = 0
      this.personForm = {}
      this.submitting = false

      if(person != null) {
        this.person = _.cloneDeep(person)
        this.personId = person.id
      }
      if(this.person.title == null)
        this.person.title = 'Mr'

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var personData = _.cloneDeep(this.$data.person)
      personData.labelList = personData.labelList.map(label => label.id)

      if(this.isCreateMode) {
        this.$apiService.contactService.createContactPerson(this.contactId, personData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.personForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.contactService.updateContactPerson(this.contactId, this.personId, personData)
        .then(response => {
          this.submitting = false
          this.modalClosed(response.data.id)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.personForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>